import { useRef } from "react";
import twoIphones from "../../../assets/general/two-iphones.png";
import { useScrollReveal } from "../../../hooks/useScrollReveal";

export function TextImage() {
  const sectionRef = useRef<HTMLElement>(null);

  useScrollReveal(sectionRef, { targets: ".left" });
  useScrollReveal(sectionRef, { targets: ".right img", delay: 0.15 });

  return (
    <section
      ref={sectionRef}
      id="section-six"
      className="section section-masthead text-left bg-dark-1"
      data-arts-theme-text="light"
    >
      <div className="flex-column right-menu-padding left-section-padding">
        <div className="sixth-section">
          <div className="left">
            <div className="section-masthead__heading">
              <p>
                We understand the uniqueness of each project along with the role of each user,
                and the necessity for flexibility.{" "}
                <span className="legal-highlighted">360PLUS</span> is built to support the
                various industry product types, as well as the diversity of contributors on any
                project.
              </p>
            </div>
          </div>
          <div className="right">
            <img src={twoIphones} alt="360PLUS on mobile" />
          </div>
        </div>
      </div>
    </section>
  );
}
